import { Component, OnInit } from '@angular/core';
import { BaseTableComponent } from '../../../shared/class/base-table-component.class';
import { ResponseSummaryFilter } from '../../models/responseSummaryFilter';

@Component({
  selector: 'app-response-summary',
  templateUrl: './response-summary.component.html',
  styleUrls: ['./response-summary.component.scss']  // Corrected styleUrls to plural
})
export class ResponseSummaryComponent extends BaseTableComponent implements OnInit {

  dataList: ResponseSummaryFilter[] = [];

  ngOnInit(): void {
    this.dataList = [
      {
        id: 1,
        totalBooksEntries: 120,
        totalGSTR2BEntries: 100,
        matchedBooksEntries: 90,
        matchedGSTR2BEntries: 85,
        unmatchedBooksEntries: 30,
        unmatchedGSTR2BEntries: 15,
        booksMatchPercentage: 75,
        gstr2BMatchPercentage: 80,
        orgId: 101,  // Added orgId
      },
    ];
  }
}
